import React from 'react';
import type { AuditTrailSummaryStats } from '../../types/acknowledgementAuditTrail.types';

interface AcknowledgementAuditTrailSummaryCardsProps {
  stats: AuditTrailSummaryStats;
  loading?: boolean;
}

const SUMMARY_ITEMS = [
  { key: 'totalRecords' as const, label: 'Total records' },
  { key: 'acknowledged' as const, label: 'Acknowledged' },
  { key: 'pending' as const, label: 'Pending' },
  { key: 'unacknowledged' as const, label: 'Unacknowledged' },
  { key: 'auditEvents' as const, label: 'Audit events' },
];

export default function AcknowledgementAuditTrailSummaryCards({
  stats,
  loading = false,
}: Readonly<AcknowledgementAuditTrailSummaryCardsProps>) {
  return (
    <div
      className={['crd-kpi-grid', 'aat-kpi-grid', loading ? 'crd-kpi-grid--loading' : '']
        .filter(Boolean)
        .join(' ')}
    >
      {SUMMARY_ITEMS.map(item => (
        <article
          key={item.key}
          className="crd-kpi-card"
        >
          <div className="crd-kpi-card-body">
            <p className="crd-kpi-label">{item.label}</p>
            <p className="crd-kpi-value">{loading ? '—' : String(stats[item.key])}</p>
          </div>
        </article>
      ))}
    </div>
  );
}
